import { useState} from 'react';

import { useRequest } from 'ahooks';
import { thinktankSearch } from '../../../axios/api'

function useThinktankSearch(){
  const [queryArgs, setQueryArgs] = useState({
    theme_id: "",
    search_content: "",
    order_by: "" //  "relevance"/"time"
  })
  const [displayData ,setDisplayData] = useState(undefined)

    const { loading, data, run } = useRequest(
        async () => {
          try {
            const resp = await thinktankSearch({...queryArgs})
            return resp?.data?.content_item_list ?? [];
          } catch (error) {
            console.log(error)
            return [];
          }
        },
        {
            refreshDeps: [queryArgs],
            retryCount: 1,
            debounceWait: 360,
            ready:queryArgs?.search_content !== ''
        }
    );
    const setQuery = (params) => {
      setQueryArgs((oldValues) => {
        return {
          ...oldValues,
          ...params,
        };
      });
  };
    const refresh = () => {
      run()
    };
    const setDisplayQuery =(params) => {
      setDisplayData(params?.from_think_tank === 'all' ? data :
        data?.filter(item=>item?.from_think_tank === params?.from_think_tank)
      )
    }
  
    return {
        loading,
        data,
        displayData:displayData ?? data,
        setQuery,
        setDisplayQuery
    }
}

export default useThinktankSearch